
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import CountyValidityCheckActivitiesTimelineItem from "@/views/shared/quotes/QuotesActivities/CountyValidityCheckActivitiesTimelineItem.vue";
interface ICountyValidityActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "countyValidityCheckActivitiesView",
  components: { CountyValidityCheckActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): ICountyValidityActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_COUNTY_VALIDITY_CHECK_FAILURE,
          ADD_COUNTY_VALIDITY_CHECK_SUCCESS,
          `.replace(/\s/g, ""),
        activityType: "CountyValidityCheckActivity"
      };
    }
  }
});
